/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billing_Ledger_EmptyInputs */

const cs_billing_ledger_empty = /** @type {(inputs: Billing_Ledger_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Žádné pohyby.`)
};

const en_billing_ledger_empty = /** @type {(inputs: Billing_Ledger_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No ledger entries.`)
};

/**
* | output |
* | --- |
* | "No ledger entries." |
*
* @param {Billing_Ledger_EmptyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const billing_ledger_empty = /** @type {((inputs?: Billing_Ledger_EmptyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_Ledger_EmptyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_billing_ledger_empty(inputs)
	return cs_billing_ledger_empty(inputs)
});